<template>
  <div class="container white pa-0">
    <!-- alerta -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="editDados">
      <v-card class="pa-3">
        <span class="title total">Editar dados:</span>
        <v-divider></v-divider>
        <v-btn icon class="float" @click="(editDados = !editDados), getUser()">
          <v-icon>close</v-icon>
        </v-btn>
        <v-flex xs12>
          <v-text-field
            v-if="this.user.cpf === null"
            color="grey darken-2"
            v-mask="'###.###.###-##'"
            label="CPF"
            v-model="user.cpf"
          ></v-text-field>
          <v-text-field
            v-if="this.user.drive_licence === null"
            color="grey darken-2"
            v-mask="'###########'"
            label="CNH"
            v-model="user.drive_license"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-model="user.phone"
            v-mask="'(##)#####-####'"
            label="Telefone"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-model="birthday"
            v-mask="'##/##/####'"
            label="Data de Nascimento"
          ></v-text-field>

          <v-btn large class="btnColor ma-0 w-100 mt-3" @click="updateUser()">
            <span class="font-weight-bold">SALVAR DADOS</span>
          </v-btn>
        </v-flex>
      </v-card>
    </v-dialog>

    <!--
    <v-dialog v-model="editAdress">
      <v-card class="pa-3">
        <span class="title total">Editar Endereço:</span>
        <v-divider></v-divider>
        <v-btn
          icon
          class="float"
          @click="(editAddress = !editAddress), getAddress(user.id_address)"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-flex xs12>
          <v-text-field
            color="grey darken-2"
            v-on:blur="validaCep()"
            v-model="address.zip"
            v-mask="'#####-###'"
            label="CEP"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-model="address.street"
            label="Rua"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            type="number"
            v-model="address.number"
            label="Número"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-model="address.address_formatted"
            label="Complemento"
            placeholder="Casa/Apartamento-Bloco/Outros"
            maxlength="30"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-model="address.neighborhood"
            label="Bairro"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-model="address.city"
            label="Cidade"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-model="address.state"
            label="Estado"
            v-mask="'AA'"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-model="address.neighborhood"
            label="Bairro"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-model="address.city"
            label="Cidade"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-model="address.state"
            label="Estado"
          ></v-text-field>
          <v-btn
            :disabled="addressController.validaAddress(address)"
            large
            class="btnColor ma-0 w-100 mt-3"
            @click="saveAddress()"
          >
            <span class="font-weight-bold">Salvar endereço</span>
          </v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
    -->

    <verifyNumber
      v-if="showVerifyNumber"
      :show="showVerifyNumber"
      @close="showVerifyNumber = false"
      @closeModal="(showVerifyNumber = false), getUser()"
    ></verifyNumber>

    <ModalCnh
      :show="showCnhModal"
      :internal="true"
      @success="showCnhModal = false"
      @close="showCnhModal = false"
    ></ModalCnh>

    <v-dialog v-model="editSenha">
      <v-card class="pa-3">
        <span class="title total">Editar senha:</span>
        <v-divider></v-divider>
        <v-btn icon class="float" @click="editSenha = !editSenha">
          <v-icon>close</v-icon>
        </v-btn>
        <v-flex xs12>
          <v-text-field
            color="grey darken-2"
            label="Nova Senha"
            type="password"
            v-model="newPwd"
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            label="Confirmar Senha"
            type="password"
            v-model="confirmPwd"
          ></v-text-field>

          <v-btn large class="btnColor ma-0 w-100 mt-3" @click="savePassword()">
            <span class="font-weight-bold">SALVAR</span>
          </v-btn>
        </v-flex>
      </v-card>
    </v-dialog>

    <v-layout column class="menu w-100 white">
      <v-card elevation="2" tile>
        <v-layout
          align-center
          justify-space-around
          class="py-2 px-3 colorSelectedBack sizeTop"
        >
          <img
            :src="require(`@/assets/logos/usecargobranco.png`)"
            alt="pickndrive"
            style="width: auto; height:39px;"
          />
        </v-layout>
      </v-card>
    </v-layout>

    <div style="height:48px"></div>

    <v-card class="ma-2 pa-3 text-left card">
      <span class="title colorSelected font-weight-medium">Dados pessoais</span>
      <v-divider class="my-2"></v-divider>
      <v-btn
        text
        icon
        small
        class="float"
        @click="(editDados = !editDados), (phoneNumber = user.phone)"
      >
        <v-icon class="colorSelected">create</v-icon>
      </v-btn>
      <v-layout column px-3>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium">Nome:</span>
          <span class="subheading grey--text text--darken-2 pl-2">{{
            user.name
          }}</span>
        </v-layout>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium">CPF:</span>
          <span class="subheading grey--text text--darken-2 pl-2">{{
            user.cpf
          }}</span>
        </v-layout>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium">CNH:</span>
          <span class="subheading grey--text text--darken-2 pl-2">{{
            user.drive_license
          }}</span>
        </v-layout>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium"
            >Data de Nascimento:</span
          >
          <span class="subheading grey--text text--darken-2 pl-2">{{
            birthday
          }}</span>
        </v-layout>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium"
            >Telefone:</span
          >
          <span class="subheading grey--text text--darken-2 pl-2">{{
            user.phone
          }}</span>
        </v-layout>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium"
            >Email:</span
          >
          <span class="subheading grey--text text--darken-2 pl-2">{{
            user.email
          }}</span>
        </v-layout>
      </v-layout>
    </v-card>

    <!-- <v-card class="ma-2 pa-3 text-left card">
      <span class="title colorSelected font-weight-medium">Endereço</span>
      <v-divider class="my-2"></v-divider>
      <v-btn text icon small class="float" @click="editAddress = !editAddress">
        <v-icon class="colorSelected">create</v-icon>
      </v-btn>
      <v-layout column px-3>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium">CEP:</span>
          <span class="subheading grey--text text--darken-2 pl-2">{{
            address.zip
          }}</span>
        </v-layout>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium">Rua:</span>
          <span class="subheading grey--text text--darken-2 pl-2">{{
            address.street
          }}</span>
        </v-layout>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium"
            >Número:</span
          >
          <span class="subheading grey--text text--darken-2 pl-2">{{
            address.number
          }}</span>
        </v-layout>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium">Complemento:</span>
          <span class="subheading grey--text text--darken-2 pl-2">{{address.address_formatted}}</span>
        </v-layout>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium"
            >Bairro:</span
          >
          <span class="subheading grey--text text--darken-2 pl-2">{{
            address.neighborhood
          }}</span>
        </v-layout>
        <v-layout row>
          <span class="subheading colorSelected font-weight-medium"
            >Cidade:</span
          >
          <span class="subheading grey--text text--darken-2 pl-2">{{
            address.city
          }}</span>
        </v-layout>
      </v-layout>
    </v-card> -->

    <v-card class="ma-2 pa-3 card">
      <span class="title colorSelected font-weight-medium">Senha</span>
      <v-btn text icon small class="float" @click="editSenha = !editSenha">
        <v-icon class="colorSelected">create</v-icon>
      </v-btn>
    </v-card>

    <div class="text-center w-100 mt-4">
      <v-btn
        large
        style="width:96%;"
        class="btnColorS white--text mx-0"
        @click="termsDialog = true"
      >
        <span>VISUALIZAR TERMOS DE USO</span>
      </v-btn>
    </div>

    <div class="text-center w-100 mt-4 exit-button" @click="logout()">
      <span>SAIR</span>
      <v-icon right color="#016ea7">exit_to_app</v-icon>
    </div>

    <div style="height:66px"></div>

    <terms
      :show="termsDialog"
      :configs="this.configurations"
      :showButtons="false"
      @closeTermsDialog="termsDialog = false"
      @requestCreate="termsDialog = false"
    ></terms>
  </div>
</template>

<script>
import theming from '../../mixins/theming';
import AuthController from './../../controllers/AuthController.js';
import UserController from './../../controllers/UserController.js';
// import AddressController from './../../controllers/AddressController.js';
import CnhController from './../../controllers/CnhController';
import User from './../../models/User.js';
import moment from 'moment';
// import MaskHelper from '../../helpers/MaskHelper';
// import Address from './../../models/Address.js';
// import axios from 'axios';
import verifyNumber from './ModalVerifyNumber.vue';
import ModalCnh from './ModalCnh.vue';
import terms from './../shared/NewUserTerms.vue';
import ConfigurationController from '../../controllers/ConfigurationController';

export default {
  mixins: [theming],

  components: {
    verifyNumber,
    ModalCnh,
    terms,
  },

  async created() {
    await this.getConfigurations();
    await this.getUser();
    await this.verifyCnhUpload();
  },

  data() {
    return {
      editDados: false,
      editSenha: false,
      editAddress: false,
      editCNH: false,
      authController: new AuthController(this.$resource, this.$router),
      userController: new UserController(this.$resource),
      // addressController: new AddressController(this.$resource),
      cnhController: new CnhController(this.$resource),
      configurationController: new ConfigurationController(this.$resource),
      // address: new Address(),
      user: new User(),
      newPwd: null,
      confirmPwd: null,
      snackbarText: '',
      snackbarColor: '',
      snackbar: false,
      taken: false,
      birthday: null,
      cnhImg: null,
      showVerifyNumber: false,
      showCnhModal: false,
      phoneNumber: null,
      client_id: localStorage.getItem('client_id'),
      configurations: {},
      termsDialog: false,
    };
  },

  methods: {
    invite() {
      return this.$router.push({ name: 'invite' });
    },

    async getConfigurations() {
      this.configurations = await this.configurationController.getAll(
        this.client_id
      );
    },

    async verifyCnhUpload() {
      await this.cnhController.consultarCnhValidaByUserId().then(
        res => {
          if (res.length == 0) {
            this.showCnhModal = true;
          }
        },
        err => {
          console.log(err);
          this.showCnhModal = true;
        }
      );
    },

    logout() {
      this.authController.logout();
    },

    verifyChangeNumber() {
      if (this.phoneNumber != this.user.phone) {
        this.user.confirmed_sms = false;
        return true;
      }
      return false;
    },

    async getUser() {
      await this.userController
        .getUserData()
        .then(res => {
          this.user = res.user;
          if (this.user.cnh_url) {
            this.taken = true;
          }
          if (this.user.birthday) {
            this.birthday = moment(this.user.birthday)
              .utc()
              .format('DD/MM/YYYY');
          }
          // if (this.user.id_address) this.getAddress(this.user.id_address);
        })
        .catch(error => {
          this.alert(error.body.message, 'error');
        });
    },

    async updateUser() {
      this.user.birthday = moment(this.birthday, 'DD/MM/YYYY');
      this.user.birthday = this.user.birthday.format('YYYY-MM-DD');
      let verifyNumber = await this.verifyChangeNumber();
      await this.userController
        .partialUpdate(this.user)
        .then(res => {
          this.editDados = !this.editDados;
          this.alert('Salvo com sucesso!', 'success');
          verifyNumber
            ? (this.showVerifyNumber = true)
            : (this.showVerifyNumber = false);
        })
        .catch(e => {
          this.alert(e.message, 'error');
        });
    },

    // async getAddress(address_id) {
    //   this.address = await this.addressController.getAddressById(address_id);
    // },

    // saveAddress() {
    //   if (this.user.id_address) this.updateAddress();
    //   else
    //     this.addressController
    //       .create(this.address)
    //       .then(res => {
    //         // a mensagem de sucesso está errada
    //         this.alert(res.message, 'success');
    //         this.editAdress = !this.editAdress;
    //         this.user.id_address = res.id_address;
    //       })
    //       .catch(e => this.alert(e, 'error'));
    // },

    // updateAddress() {
    //   this.addressController
    //     .update(this.address.id, this.address)
    //     .then(res => {
    //       this.alert('Salvo com sucesso!', 'success');
    //       this.editAdress = !this.editAdress;
    //     })
    //     .catch(e => {
    //       this.alert(e, 'error');
    //     });
    // },

    alert(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    async savePassword() {
      if (this.newPwd != this.confirmPwd) {
        this.alert(
          'As senhas não se coincidem! Por favor, tente novamente.',
          'error'
        );
        this.newPwd = null;
        this.confirmPwd = null;
        return;
      } else if (!this.newPwd) {
        this.alert('Senha inválida. Por favor, tente novamente.', 'error');
        this.newPwd = null;
        this.confirmPwd = null;
        return;
      }
      this.userController
        .resetPassword(this.user.id, this.newPwd, false)
        .then(res => this.alert('Senha alterada com sucesso!', 'success'))
        .catch(e => this.alert(e.message, 'error'))
        .finally(() => (this.editSenha = false));
    },

    // validaCep() {
    //   axios
    //     .get(`https://viacep.com.br/ws/${this.address.zip}/json/`)
    //     .then(response => {
    //       this.address.state = response.data.uf;
    //       this.address.street = response.data.logradouro;
    //       this.address.city = response.data.localidade;
    //       this.address.neighborhood = response.data.bairro;
    //     })
    //     .catch(error => {
    //       this.alert('CEP inválido.', 'error');
    //     });
    // },

    async onFileSelected(e) {
      let image = e.target.files[0];
      // compactação inicio
      const width = 100;
      const fileName = e.target.files[0].name;
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = event => {
        const img = new Image();
        img.src = event.target.result;
        (img.onload = async () => {
          const elem = await document.createElement('canvas');
          const scaleFactor = width / img.width;
          elem.width = width;
          elem.height = img.height * scaleFactor;
          const ctx = elem.getContext('2d');
          // img.width and img.height tem as dimensões originais
          await ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          await ctx.canvas.toBlob(
            blob => {
              const file = new File([blob], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              image = file;
            },
            'image/jpeg',
            1
          );

          this.cnhImg = image;
          this.taken = !this.taken;
          await this.saveImgChn(this.cnhImg);
        }),
          (reader.onerror = error => console.log(error));
      };
    },

    saveImgChn(img) {
      let data = new FormData();
      data.append(`cnh`, img);
      this.userController
        .saveImgCnh(data)
        .then(res => this.alert(res.message, 'success'))
        .catch(error => this.alert(error.message, 'error'));
    },
  },
};
</script>

<style scoped>
.exit-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.exit-button span {
  font-weight: 700px;
  color: #016ea7;
}

.container {
  position: relative;
  height: 100vh;
}

.sizeTop {
  height: 48px;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.colorSelectedBack {
  background-color: var(--secondary-color) !important;
}

.colorSelected {
  color: var(--secondary-color) !important;
}

.card {
  position: relative;
}

.cardRadius {
  border-radius: 4px;
}

.float {
  position: absolute;
  top: 4px;
  right: 3px;
  outline: none;
}

.floatMiddle {
  position: absolute;
  outline: none;
  left: 50%;
  margin-left: -20px;
  top: 50%;
  margin-top: -20px;
}

.btnColor {
  background-color: var(--secondary-color) !important;
  color: var(--primary-color) !important;
}
.btnColorS {
  background-color: var(--secondary-color) !important;
}

.colorBtn {
  color: #993399;
}
</style>
